import repository from '@/services/repository';

const resource = '/jobs';

export default {
    generateInvoicesFromMachineryRental() {
        return repository.get(`${resource}/GenerateInvoicesForRentals`);
    },
};
